import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function InsurancePolicy(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      ...rest,
      "data-tidal": "TidalIllustration",
      "data-tidal-illustration": "InsurancePolicy",
      sx,
      viewBox,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M30.6316 41H7.89474c-.50252 0-.98445-.1996-1.33978-.555C6.19962 40.0897 6 39.6078 6 39.1053V6.89474c0-.50252.19962-.98445.55496-1.33978C6.91029 5.19962 7.39222 5 7.89474 5H24.8811l7.6452 7.5032v26.6021c0 .5025-.1996.9844-.5549 1.3397-.3554.3554-.8373.555-1.3398.555Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M30.5145 30.0224c-5.4-5.351-11.8801 1.0019-6.4878 6.4849L30.5145 43l6.4647-6.4694c5.3692-5.4054-1.0646-11.8903-6.4647-6.5082Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M39.2305 34.2277h-4.0027c-.1152-.0016-.2292.0226-.3329.0707l-1.8867.8978-1.1542-2.1987c-.0678-.1259-.1736-.2294-.3037-.2972-.13-.0678-.2784-.0967-.4259-.083-.1475.0137-.2873.0694-.4012.1599-.114.0905-.1969.2116-.238.3476l-.9618 3.2096-2.6192-4.9488c-.0663-.1242-.1696-.2269-.2969-.2951-.1272-.0683-.2728-.099-.4183-.0885-.1455.0106-.2845.0621-.3994.1479-.115.0859-.2009.2024-.2468.3347l-.9544 2.736h-2.8485c-.1963 0-.3844.0745-.5232.2071-.1387.1325-.2167.3124-.2167.4999s.078.3673.2167.4999c.1388.1325.3269.207.5232.207h3.3812c.156-.0001.308-.0473.4343-.1349.1262-.0876.2202-.2111.2686-.3529l.5623-1.6048 2.6709 5.0336c.0621.1361.1674.25.3011.3257.1336.0757.2888.1093.4435.096.1547-.0133.3011-.0728.4185-.1701.1173-.0972.1996-.2273.2353-.3718l.9618-3.1955.6289 1.2019c.0874.1677.2409.2955.4268.3551.1859.0597.389.0464.5647-.037l2.3898-1.1382h3.8325c.1963 0 .3844-.0745.5232-.2071.1387-.1326.2167-.3124.2167-.4999s-.078-.3673-.2167-.4999c-.1388-.1326-.3269-.207-.5232-.207h-.0296Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M24.9473 5v7.5789h7.5789L24.9473 5Z", fill: theme.vars.palette.primary.dark }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M21.1575 13.5261H10.7364c-.2512 0-.4922-.0998-.6699-.2775-.17763-.1777-.27744-.4186-.27744-.6699 0-.2512.09981-.4922.27744-.6699.1777-.1776.4187-.2775.6699-.2775h10.4211c.2512 0 .4922.0999.6699.2775.1776.1777.2775.4187.2775.6699 0 .2513-.0999.4922-.2775.6699-.1777.1777-.4187.2775-.6699.2775Zm5.6842 4.7368H10.7364c-.2512 0-.4922-.0998-.6699-.2775-.17763-.1776-.27744-.4186-.27744-.6698 0-.2513.09981-.4923.27744-.6699.1777-.1777.4187-.2775.6699-.2775h16.1053c.2513 0 .4922.0998.6699.2775.1777.1776.2775.4186.2775.6699 0 .2512-.0998.4922-.2775.6698-.1777.1777-.4186.2775-.6699.2775Zm-2.8421 4.7369H10.7364c-.2512 0-.4922-.0998-.6699-.2775-.17763-.1777-.27744-.4186-.27744-.6699s.09981-.4922.27744-.6699c.1777-.1777.4187-.2775.6699-.2775h13.2632c.2512 0 .4922.0998.6699.2775.1776.1777.2775.4186.2775.6699s-.0999.4922-.2775.6699c-.1777.1777-.4187.2775-.6699.2775Zm-2.8421 4.7368H10.7364c-.2512 0-.4922-.0998-.6699-.2775-.17763-.1776-.27744-.4186-.27744-.6699 0-.2512.09981-.4922.27744-.6698.1777-.1777.4187-.2775.6699-.2775h10.4211c.2512 0 .4922.0998.6699.2775.1776.1776.2775.4186.2775.6698 0 .2513-.0999.4923-.2775.6699-.1777.1777-.4187.2775-.6699.2775Zm-2.8421 5.6842h-7.579c-.2512 0-.4922-.0998-.6699-.2775-.17763-.1776-.27744-.4186-.27744-.6698 0-.2513.09981-.4923.27744-.6699.1777-.1777.4187-.2775.6699-.2775h7.579c.2512 0 .4922.0998.6699.2775.1776.1776.2774.4186.2774.6699 0 .2512-.0998.4922-.2774.6698-.1777.1777-.4187.2775-.6699.2775Z",
            fill: theme.vars.palette.primary.light
          }
        )
      ]
    }
  );
}
InsurancePolicy.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "InsurancePolicy"
};
validateTidalLicense();
export {
  InsurancePolicy
};
//# sourceMappingURL=InsurancePolicy.js.map
